<template>
  <div class="container-fluid py-2">
    <div class="table-responsive overflow-auto" style="height: 88vh">
      <div class="d-flex">
        <h3 class="text-dark font-weight-bolder mr-auto mb-0">
          Logs By Manning From [{{params.dateFrom|moment('DDMMMYYYY') }}] to [{{ params.dateTo|moment('DDMMMYYYY')}}]
        </h3>

        <div>
          <div class="input-group form-inline justify-content-between mt-2">
            <label for="date-from" class="font-weight-bolder small mr-2">Date From:</label>
            <input type="date" id="date-from" class="form-control form-control-sm form-control-xs rounded mr-2"
                   v-model="params.dateFrom">
            <label for="date-to" class="font-weight-bolder small mt-1 mr-2 ml-3">Date To:</label>
            <input type="date" id="date-to" class="form-control form-control-sm form-control-xs rounded mr-2"
                   v-model="params.dateTo">
            <button class="btn btn-sm btn-xs btn-dark"
                    @click="updateCrewPerManningReport">
              <font-awesome-icon icon="search" />
              Search
            </button>
            <button class="btn btn-sm btn-xs btn-outline-info mx-2 font-weight-bolder"
                    title="Generate PDF Report"
                    @click="generateCrewPerManningReport"
                    :disabled="!crewPerManningReport.length"
            >
              <font-awesome-icon :icon="pdfLoading ? 'spinner' : 'file-pdf'" class="text-danger" :spin="pdfLoading" size="xl"/>
              PDF
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between my-3">
        <button class="btn btn-sm btn-xs font-weight-bolder"
                :class="{
          'btn-dark': manningKey.id == params.manningId,
          'disabled': loading
        }"
                v-for="manningKey in manningKeys"
                :key="manningKey.id"
                @click="params.manningId = manningKey.id">
          [{{ manningKey.alias }}]
        </button>
      </div>

      <table class="table table-sm table-bordered text-center table-hover cell-middle sticky-header">
        <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">[Crewipn]</th>
          <th scope="col">[Last Name]</th>
          <th scope="col">[First Name]</th>
          <th scope="col">[M. Name]</th>
          <th scope="col">[Log Date]</th>
          <th scope="col">[IP Address]</th>
          <th scope="col">[Manning]</th>
        </tr>
        </thead>
        <tbody v-if="loading">
        <tr>
          <td colspan="100%">
            <base-loader />
          </td>
        </tr>
        </tbody>
        <tbody class="text-left" v-else>
        <tr v-for="(crew, index) in crewPerManningReport" :key="crew.id">
          <td class="text-right">{{ index + 1 }}</td>
          <td>{{ crew.crewIpn }}</td>
          <td>{{ crew.last_name }}</td>
          <td>{{ crew.first_name }}</td>
          <td>{{ crew.middle_name }}</td>
          <td class="text-right">{{ crew.logDate }}</td>
          <td class="text-center">{{ crew.ip }}</td>
          <td class="text-center" :title="crew.manningName">
            {{ crew.manningAlias }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

import { GET_CREW_PER_MANNING_REPORT } from "@/config/constants.config";

import {AppService} from "@/service/app.service";
import {DateService} from '@/service/date.service';

export default {
  name: 'CrewPerManningReport',

  components: {
  },

  data() {
    return {
      params: {
        dateFrom: DateService.firstOfMonth(new Date(DateService.addMonth(new Date(), -1))),
        dateTo: DateService.lastOfMonth(new Date(DateService.addMonth(new Date(), -1))),
        // dateFrom: '2020-11-01',
        // dateTo: '2020-11-30',
        manningId: 1,
      },
      loading: false,
      pdfLoading: false,
    };
  },

  methods: {
    ...mapActions([
      'getManningKeys',
      'getCrewPerManningReport',
    ]),

    async updateCrewPerManningReport() {
      this.loading = true;
      await this.getCrewPerManningReport(this.params);
      this.loading = false;
    },

    eliteDateFormat(date){
      return AppService.dateEliteFormat(date);
    },

    async initializeData() {
      await this.getManningKeys();
      this.params.manningId = this.manningKeys[0].id
      this.updateCrewPerManningReport();
    },

    async generateCrewPerManningReport() {
      let params = Object.assign({}, this.params);
      params['report'] = 1;
      let manning = this.manningKeys.find(manning => manning.id == this.params.manningId);
      params['manningName'] = manning.alias;
      this.pdfLoading = true;
      await AppService.generateReport(GET_CREW_PER_MANNING_REPORT, params);
      this.pdfLoading = false;
    }

  },

  computed: {
    ...mapGetters([
      'manningKeys',
      'crewPerManningReport',
    ]),
  },

  created() {
    this.initializeData();
  },

  watch: {
    'params.manningId'() {
      this.updateCrewPerManningReport();
    },
  },

};
</script>
